import sign_up from './signUp.json';

const i18n = {
  sign_up,
};

export default i18n;
